import React from 'react';
import '../ContactPage/ContactPage.scss';

const ContactPage = () => {
  return (
    <div className='contact-page'>
      <div className='contact-page__container'>
        <h2 className='contact-page__title'>Our contacts</h2>
        <p style={{paddingTop:'20px'}}>Lviv, Forum Lviv shopping center</p>
        <p style={{paddingTop:'20px'}}>Contacts:<a href="tel:+380671234567">+38 (067) 123-45-67</a></p>
        <p style={{paddingTop:'20px'}}>The store is located on the first floor of Forum Lviv shopping center, in the center of the shopping center. Parking spaces are available on the territory of the shopping center.</p>
        <p style={{paddingTop:'20px'}}>From 10:00 to 21:00, without lunch.</p>

        {/* Виджет Google Maps */}
        <div style={{paddingTop:'20px'}}>
            <iframe
            title="Google Maps"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2563.709227585212!2d24.019114615716594!3d49.832707179394734!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473a2871e82e0911%3A0x48676b2da6b42fc2!2sForum%20Lviv!5e0!3m2!1sen!2sua!4v1628741234567!5m2!1sen!2sua"
            width="100%"
            height="450"
            allowFullScreen=""
            loading="lazy"
            ></iframe>
        </div>
        
      </div>
    </div>
  );
};

export default ContactPage;
